import api from "@core/plugins/api";
import { SignupDTO } from "@core/dto";

const doesEmailExistUrl = (email) => `/inscription/${email}/doesExist`;
const signupUrl = () => `/inscription/etab`;

export class EtabSignupService {
  // Account signup is a mix of account and profile
  // All the data is sent to the same api, we create a user and an etab at the same time
  static async create({ signupData }) {
    try {
      if (signupData) {
        const dto = new SignupDTO(signupData);
        const data = dto.prepareCreateData();
        return api.public.post(signupUrl(), data);
      }
      throw new Error("Data not provided");
    } catch (error) {
      throw error;
    }
  }

  static async doesEmailExist({ email }) {
    try {
      if (email) {
        const response = await api.public.get(doesEmailExistUrl(email));
        const doesEmailExist = response && response.data;
        return doesEmailExist === "true";
      }
      throw new Error("Data not provided");
    } catch (error) {
      throw error;
    }
  }
}
